import { render } from "./AdditionalFields.vue?vue&type=template&id=780bd874&scoped=true"
import script from "./AdditionalFields.vue?vue&type=script&lang=js"
export * from "./AdditionalFields.vue?vue&type=script&lang=js"

import "./AdditionalFields.vue?vue&type=style&index=0&id=780bd874&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/admin.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-780bd874"]])

export default __exports__